import React, { useCallback, useState } from 'react'
import AsyncSelect from 'react-select3/async'
import request from 'superagent'
import _ from 'lodash'

export default function ({connectionId, onSelectSite, defaultValue}) {
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  const getOptions = (inputValue) => {
    // clear current selected value, otherwise loaded options will all be selected :(
    setSelectedValue(null);

    return request.get(`/rpc/integrations/connections/${connectionId}/sharepoint/sites`)
      .query({query: inputValue.trim()})
      .then(response => response.body.sites);
  };

  const debouncedGetOptions = useCallback(
    _.debounce(
      (inputValue, callback) => {
        getOptions(inputValue).then(options => callback(options))
      },
      500
    ),
    []
  );

  // update internal state on change an communicate the new value via onSelectSite
  const onChange = (option) => {
    setSelectedValue(option);
    onSelectSite(option);
  }

  return (
    <AsyncSelect
      label={_.get(selectedValue, 'displayName')}
      value={selectedValue}
      loadOptions={debouncedGetOptions}
      loadingMessage={() => 'Searching SharePoint Sites...'}
      noOptionsMessage={() => 'No Sites Found Matching Search Criteria.'}
      isClearable
      placeholder="Type to search SharePoint Sites.  Only full words will match."
      getOptionLabel={option => option.displayName}
      onChange={onChange}
    />
  );
}

export const FinalFormSharepointSiteSearch = ({ input: {value, onChange}, ...rest }) => {
  return <SharepointSiteSearch value={value} onSelectSite={option => onChange(option)} {...rest} />
}


// WEBPACK FOOTER //
// ./src/Integrations/connections/SharepointSiteSearch.jsx